export function stringReplace(str, oldStr, newStr) {
  let regEx = new RegExp(oldStr, 'ig');
  let result = str.replace(regEx, newStr);
  return result;
}

// Check if it's ASCII
export function isASCII(str, extended) {
  return (extended ? /^[\x00-\xFF]*$/ : /^[\x00-\x7F]*$/).test(str);
}
